<template>
  <div class="my-account fullscreen-content section">
    <div class="container">
      <div class="account-links boxed-content">
        <div class="row ns between">
          <div class="col">
            <ul>
              <li>
                <router-link :to="$i18nRoute({name: 'my-account', params:{page: 'profile'}})">{{$t('account.my_account')}}</router-link>
              </li>
              <li>
                <router-link :to="$i18nRoute({name: 'my-account', params: {page: 'orders'}})">{{$t('account.orders')}}</router-link>
              </li>
              <li>
                <router-link :to="$i18nRoute({name: 'cart'})">{{$t('account.cart')}}</router-link>
              </li>
              <li>
                <router-link :to="$i18nRoute({name: 'favorites'})">{{$t('account.favorites')}}</router-link>
              </li>
            </ul>
          </div>
          <div class="col" v-if="['md', 'lg', 'xl', 'hd', 'inf'].includes($mq)">
            <span class="logout" @click="logout()">{{$t('account.logout')}}</span>
          </div>
        </div>
      </div>

      <div class="account-content boxed-content">
        <component :is="$route.params.page"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from '@/views/my-account/Profile.vue';
import Orders from '@/views/my-account/Orders.vue';
import Order from '@/views/my-account/Order.vue';
import Coupons from '@/views/my-account/Coupons.vue';
import MakePayment from '@/views/my-account/MakePayment.vue';
export default {
  components: {
    Profile,
    Orders,
    Order,
    Coupons,
    MakePayment
  },
  name: 'my-account',
  created () {
    if (!this.$store.state.auth.is_auth) {
      this.$router.push(this.$i18nRoute({ name: 'login' }))
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('fetchAuth', false)
      window.localStorage.setItem('id_token', false)
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss">
.my-account {
  padding-top: 130px;

  @include mq($ms){
    padding-top: 90px;
  }

  .container {
    max-width: 1000px;
  }

  .account-links {
    margin-bottom: 30px;
    overflow: auto;
    ul {
      li {
        display: inline-block;
        margin-right: 30px;

        a {
          color: rgba(0, 0, 0, 0.6);
          &.router-link-exact-active {
            text-decoration: underline;
            color: $main-color;
          }
        }
      }
    }
    .logout {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .page-title {
    font-size: 24px;
    margin-top: 0;
    text-align: center;
    font-family: $font-bold;
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
    padding-bottom: 30px;
  }
}
</style>
